import { createSelector } from '@reduxjs/toolkit'
import { RootState } from "../../"

const selectEditSideBar = (state: RootState): {show: boolean} => state.editSidebar

export const editSidebarOpen = createSelector(selectEditSideBar, (editSidebar) => editSidebar)
